/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import PropTypes from 'prop-types';
import './weather-alerts-detail.scss';

function WeatherAlertDetail({
  alertType,
  severity,
  areaName,
  effectiveTimestamp,
  longDescription,
}) {
  const date = new Date(effectiveTimestamp);
  const localeString = date.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
  const severityClass = `alert-detail__severity alert-detail__${severity.toLowerCase()}`; // eslint-disable-line max-len

  return (
    <div className="alert-detail__wrapper">
      <div className="alert-detail__area-name">{areaName}</div>
      <div className="alert-detail__type">
        <span className={severityClass}>{severity}</span>
        {' '}
        {alertType}
      </div>
      <div className="alert_detail__time">{localeString}</div>
      <div className="alert_detail__description">
        {longDescription.split('\n').map((paragraph, i) => (
          // Using the array index as key here should be fine since the order of
          // these paragraphs shouldn't change.
          //
          // eslint-disable-next-line react/no-array-index-key
          <p key={i} className="alert_detail__paragraph">
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
}

WeatherAlertDetail.propTypes = {
  alertType: PropTypes.string.isRequired,
  areaName: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  effectiveTimestamp: PropTypes.string.isRequired,
  longDescription: PropTypes.string.isRequired,
};

export default WeatherAlertDetail;
